import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M8 16C5.97292 15.5333 4.29948 14.47 2.97969 12.81C1.6599 11.15 1 9.30667 1 7.28V2.4L8 0L15 2.4V7.28C15 9.30667 14.3401 11.15 13.0203 12.81C11.7005 14.47 10.0271 15.5333 8 16Z"
      fill="white"
    />
    <Path
      d="M5 13C4.725 13 4.48958 12.9067 4.29375 12.7202C4.09792 12.5337 4 12.3095 4 12.0476V7.28571C4 7.02381 4.09792 6.7996 4.29375 6.6131C4.48958 6.42659 4.725 6.33333 5 6.33333H5.5V5.38095C5.5 4.72222 5.74375 4.16071 6.23125 3.69643C6.71875 3.23214 7.30833 3 8 3C8.69167 3 9.28125 3.23214 9.76875 3.69643C10.2563 4.16071 10.5 4.72222 10.5 5.38095V6.33333H11C11.275 6.33333 11.5104 6.42659 11.7063 6.6131C11.9021 6.7996 12 7.02381 12 7.28571V12.0476C12 12.3095 11.9021 12.5337 11.7063 12.7202C11.5104 12.9067 11.275 13 11 13H5ZM5 12.0476H11V7.28571H5V12.0476ZM8 10.619C8.275 10.619 8.51042 10.5258 8.70625 10.3393C8.90208 10.1528 9 9.92857 9 9.66667C9 9.40476 8.90208 9.18056 8.70625 8.99405C8.51042 8.80754 8.275 8.71429 8 8.71429C7.725 8.71429 7.48958 8.80754 7.29375 8.99405C7.09792 9.18056 7 9.40476 7 9.66667C7 9.92857 7.09792 10.1528 7.29375 10.3393C7.48958 10.5258 7.725 10.619 8 10.619ZM6.5 6.33333H9.5V5.38095C9.5 4.98413 9.35417 4.64683 9.0625 4.36905C8.77083 4.09127 8.41667 3.95238 8 3.95238C7.58333 3.95238 7.22917 4.09127 6.9375 4.36905C6.64583 4.64683 6.5 4.98413 6.5 5.38095V6.33333Z"
      fill="#0078DA"
      stroke="#0078DA"
      strokeWidth={0.4}
    />
  </Svg>
);
export default SVGComponent;
